import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';

var MappingLogModal = function (_super) {
  __extends(MappingLogModal, _super);

  function MappingLogModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loadingStatus = false;
    _this.columns = [];
    _this.data = [];
    _this.total = 0;
    _this.searchData = {
      page_index: 1,
      page_size: 10
    };
    return _this;
  }

  MappingLogModal.prototype.onVisibleChange = function (value) {
    if (value) {
      this.searchData.page_index = 1;
      this.queryList();
    }
  };

  MappingLogModal.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, resData, _b, _c, list, _d, total;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            return [4, this.$api.shopManage.getMappingLogs({
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size,
              relation_id: this.relationId
            })];

          case 1:
            _a = _e.sent().data, resData = _a === void 0 ? {} : _a;
            _b = resData, _c = _b.list, list = _c === void 0 ? [] : _c, _d = _b.total, total = _d === void 0 ? 0 : _d;
            this.data = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  MappingLogModal.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  MappingLogModal.prototype.created = function () {
    this.columns = [{
      title: this.t('记录时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }, {
      title: this.t('操作人'),
      dataIndex: 'create_user_name',
      filterEmpty: true
    }, {
      title: this.t('操作类型'),
      dataIndex: 'operate_type_text',
      filterEmpty: true
    }, {
      title: this.t('操作内容'),
      dataIndex: 'operate_content',
      filterEmpty: true
    }];
  };

  __decorate([Prop({
    type: String,
    "default": undefined
  })], MappingLogModal.prototype, "relationId", void 0);

  __decorate([Watch('visible')], MappingLogModal.prototype, "onVisibleChange", null);

  __decorate([loading('loadingStatus')], MappingLogModal.prototype, "queryList", null);

  MappingLogModal = __decorate([Component], MappingLogModal);
  return MappingLogModal;
}(Vue);

export default MappingLogModal;